/**
 * Aplica un delta WS sobre el estado actual de resultados.
 * @param {Array} current - array actual de resultados
 * @param {Array} changed - resultados nuevos/modificados
 * @param {Array} eliminados - dorsales a eliminar
 * @returns {Array} - array actualizado
 */
/**
 * Deriva control_ultimo_id desde los datos aplanados.
 * Busca el control de mayor distancia con puesto > 0.
 */
export function deriveControlUltimoId(resultado, controles) {
  if (!controles || !controles.length) return null;
  const sorted = [...controles].sort((a, b) => a.distancia - b.distancia);
  let lastId = null;
  for (const c of sorted) {
    if (resultado['control_' + c.id + '_puesto'] > 0) {
      lastId = c.id;
    }
  }
  return lastId;
}

/**
 * Enriquece resultados con control_ultimo_id derivado.
 */
export function enrichResultados(resultados, controles) {
  return resultados.map(r => ({
    ...r,
    control_ultimo_id: deriveControlUltimoId(r, controles),
  }));
}

export function applyDelta(current, changed, eliminados = []) {
  // Clonar para no mutar
  const map = new Map();
  for (const r of current) {
    map.set(r.dorsal, r);
  }
  // Eliminar
  for (const dorsal of eliminados) {
    map.delete(dorsal);
  }
  // Añadir/actualizar
  for (const r of changed) {
    map.set(r.dorsal, { ...r, ...r.controles });
  }
  return Array.from(map.values());
}
